import "./podcast-player.scss";

import cn from "clsx";
import { Alignment, EditAttributes } from "design-system/types/types";
import { Embed } from "design-system/components/primitives/embed/embed";
import { ReactNode } from "react";
import {
  ComponentHeader,
  ComponentHeaderProps,
} from "design-system/components/primitives/component-header/component-header";
import { createPodcastEmbedProps } from "./create-podcast-embed-props";
import { Accordion } from "design-system/components/blocks/accordion/accordion";
import {
  MediaAsset,
  MediaAssetProps,
} from "design-system/components/primitives/media-asset/media-asset";

export interface PodcastPlayerProps {
  align?: Alignment;
  embedUrl?: string;
  srcType?: "Libsyn" | "Megaphone" | "Embed Url" | "Video";
  episodeNum?: string;
  video?: MediaAssetProps;
  title?: string;
  header?: ComponentHeaderProps;
  caption?: ReactNode;
  transcript?: ReactNode;
  editAttributes?: { title?: EditAttributes; caption?: EditAttributes };
}

export function PodcastPlayer({
  align = "center",
  embedUrl,
  srcType,
  episodeNum,
  video,
  title,
  header,
  caption,
  transcript,
  editAttributes,
}: PodcastPlayerProps) {
  if (!srcType || !title) return null;

  const { src, height } = createPodcastEmbedProps({
    srcType,
    episodeNum,
    embedUrl,
  });

  if (srcType === "Video") {
    if (!video) return null;
  } else {
    if (!src) return null;
  }

  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-component--podcast-player",
  );

  return (
    <div className={wrapperClass} data-region="cb__podcast-player">
      {header && (
        <div className="hbs-podcast-player__header">
          <ComponentHeader {...header} />
        </div>
      )}

      <div
        {...editAttributes?.title}
        className="hbs-podcast-player__embed"
        data-chromatic="ignore"
      >
        {srcType === "Video" && video && <MediaAsset {...video} />}

        {src && srcType !== "Video" && (
          <Embed
            src={src}
            title={title}
            aspectRatio={false}
            width={864}
            height={height}
          />
        )}
      </div>

      {caption && (
        <div
          {...editAttributes?.caption}
          className="hbs-podcast-player__caption"
        >
          {caption}
        </div>
      )}

      {transcript && (
        <Accordion
          items={[
            { title: "Transcript", HeadingLevel: "h3", children: transcript },
          ]}
        />
      )}
    </div>
  );
}
